'use client';

import { Image } from 'atoms/Image/Image';
import sslIcon from './images/sslIcon.svg';
import trustedIcon from './images/trustedIcon.svg';
import styles from './styles.module.css';

export const TrustedIcon = () => (
  <Image src={trustedIcon.src} alt="trustedIcon" className={styles.icon} />
);

export const SslIcon = () => (
  <Image src={sslIcon.src} alt="sslIcon" className={styles.icon} />
);
